const Popover = {
  baseStyle: {
    content: {
      background: "gray.800"
    },
    arrow: {
      background: "gray.800"
    }
  }
};

export default Popover;
